import { createSlice } from '@reduxjs/toolkit';

import { ScopeType } from '~shared/types';

type ScopeStateType = {
  scope: ScopeType;
};

const initialState: ScopeStateType = {
  scope: 'lessor',
};

const scopeSlice = createSlice({
  name: 'scope',
  initialState,
  reducers: {
    setScope: (state, action) => {
      state.scope = action.payload;
    },
  },
});

export const { setScope } = scopeSlice.actions;

export default scopeSlice.reducer;
